module.exports = __webpack_public_path__ + "static/media/banner03.ba5eee7a.qlv";